<div class="d-flex flex-column h-100 overflow-hidden">
    <!--
        Show the common-header component only for LPv4 product when no activity is launched.
        For other cases, common-header is already handled in the lo-renderer component.
        For displaying LPv4 product view, initialize common-header here since it won't be initialized in lo-renderer.
        But we can't remove LPv4 component at the top level, since LPv4 component is required for creating itemStack for back btn functionality.
    -->
    <div *ngIf="!selectedActivity" class="flex-shrink-0 w-100">
        <common-header></common-header>
    </div>
    <div class="page-wrapper d-flex align-items-center justify-content-start flex-column p-5">
        <div *ngIf="!(isLtiUser && isHideBackButton)" class="back-btn mb-4 w-md-75 w-100 px-md-5">
            <a role="button" href="javascript:void(0);" qid="scpv-link-1"
                [attr.aria-label]="'SHARED.SCOMP_VIEW.BACK' | translate" (click)="goBack()">
                <i class="fa fa-chevron-left mr-2" aria-hidden="true"></i>
                <span>
                    {{'SHARED.SCOMP_VIEW.BACK'| translate }}
                </span>
            </a>
        </div>
        <h1 class="category-heading font-weight-normal text-center mb-4 px-md-5">
            {{ categoryHeading }}
        </h1>
        <div class="category-container w-100 d-flex align-items-start justify-content-center flex-column">
            <div class="tiles-container d-flex flex-wrap justify-content-start">
                @for (item of currentItems; track item) {
                    @if (item['item-type'] === 'folder') {
                        <a role="button" href="javascript:void(0);" qid="scpv-link-2"
                            class="folder-tile rounded d-flex flex-column align-items-center justify-content-center text-center p-3"
                            (click)="nextCategory(item)">
                            @if (item.accessInfo?.totalChildCount !== 0 && item.accessInfo?.totalChildCount === item.accessInfo?.childLockCount) {
                                <svg width="28" height="36" viewBox="0 0 28 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <title>{{ 'SHARED.SCOMP_VIEW.CONTENT_ACCESS.SCREEN_READER.LOCKED' | translate }}</title>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14 0C19.3775 0 23.7636 4.24461 23.9908 9.56622L24 10V12C26.2091 12 28 13.535 28 15.4286V32.5714C28 34.465 26.2091 36 24 36H4C1.79086 36 0 34.465 0 32.5714V15.4286C0 13.535 1.79086 12 4 12V10C4 4.47715 8.47715 0 14 0ZM24 16H4V32H24V16ZM14 18C16.2091 18 18 19.7909 18 22C18 23.4797 17.1966 24.7717 16.0022 25.4636L16 28C16 29.1046 15.1046 30 14 30C12.8954 30 12 29.1046 12 28L11.9999 25.4648C10.8043 24.7731 10 23.4805 10 22C10 19.7909 11.7909 18 14 18ZM14 4C10.8046 4 8.19268 6.49784 8.01019 9.64745L8 10V12H20V10C20 6.68629 17.3137 4 14 4Z" fill="#212529"/>
                                </svg>
                            }
                            <p [title]="item.name" class="folder-name trim-text font-weight-normal mb-0">{{ item.name }}</p>
                        </a>
                    } @else if (item['item-type'] === 'resource') {
                        <a href="javascript:void(0);" qid="scpv-link-2"
                            class="activity-tile mb-2 mb-md-0 rounded text-center d-flex align-items-center justify-content-start flex-column"
                            (click)="nextCategory(item)">
                            <img *ngIf="item?.model?.url && imagesBasePath" [src]="imagesBasePath + '/' + item.model.url"
                                [attr.alt]="item.model.media_img1_alt || ''" class="activity-image img-fluid rounded"
                                imageThumbnailUpdate [imageObject]="item" />
                            @if (item.accessInfo?.isLocked) {
                                <div class="lock-cover" [ngClass]="{'position-absolute': item?.model?.url}">
                                    <svg width="40" height="53" viewBox="0 0 40 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <title>{{ 'SHARED.SCOMP_VIEW.CONTENT_ACCESS.SCREEN_READER.LOCKED' | translate }}</title>
                                        <path d="M20 0C28.2725 0 35 6.7275 35 15V17.5H37.5C38.88 17.5 40 18.62 40 20V50C40 51.38 38.88 52.5 37.5 52.5H2.5C1.12 52.5 0 51.38 0 50V20C0 18.62 1.12 17.5 2.5 17.5H5V15C5 6.7275 11.7275 0 20 0ZM5 47.5H35V22.5H5V47.5ZM31.25 25C31.94 25 32.5 25.56 32.5 26.25V43.75C32.5 44.44 31.94 45 31.25 45C30.56 45 30 44.44 30 43.75V26.25C30 25.56 30.56 25 31.25 25ZM17.5 27.5C20.2575 27.5 22.5 29.7425 22.5 32.5C22.5 34.347 21.493 35.9614 20 36.8271V40C20 41.38 18.88 42.5 17.5 42.5C16.12 42.5 15 41.38 15 40V36.8271C13.507 35.9614 12.5 34.347 12.5 32.5C12.5 29.7425 14.7425 27.5 17.5 27.5ZM20 5C14.485 5 10 9.485 10 15V17.5H30V15C30 9.485 25.515 5 20 5Z" fill="white"/>
                                    </svg>
                                </div>
                            }
                            <div class="d-flex flex-column justify-content-center align-items-center" [ngClass]="{'h-100': (!item?.model?.url)}">                       
                                <p [title]="item.name" class="activity-name trim-text font-weight-normal my-3 px-2">
                                    {{ item.name }}
                                </p>
                            </div>
                        </a>
                    }
                }
            </div>
        </div>
    </div>

    <!-- Content locked modal -->
    <button hidden data-toggle="modal" data-target="#activityLockModal" #showActivityLockModal></button>
    <div class="modal fade activity-lock-modal pr-0" id="activityLockModal" tabindex="-1" aria-labelledby="activityLockModalLabel"
      aria-hidden="true" #activityLockModal>
        <div class="modal-dialog modal-dialog-centered">
            <div class="p-3 modal-content">
                <a href="javascript:void(0)" class="close-icon" qid="scpv-alm-1" data-dismiss="modal" #activityLockModalCancel>
                    <i class="nemo-font nemo-cross gray-text" aria-hidden="true"></i>
                    <span class="sr-only">{{ 'SHARED.SCOMP_VIEW.CONTENT_ACCESS.SCREEN_READER.CLOSE_POPUP' | translate }}</span>
                </a>
                <div class="lock-container text-center">
                    <svg class="mb-2"width="32" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>{{ 'SHARED.SCOMP_VIEW.CONTENT_ACCESS.SCREEN_READER.LOCKED' | translate }}</title>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12.5 3C15.1888 3 17.3818 5.12231 17.4954 7.78311L17.5 8V9C18.6046 9 19.5 9.76751 19.5 10.7143V19.2857C19.5 20.2325 18.6046 21 17.5 21H7.5C6.39543 21 5.5 20.2325 5.5 19.2857V10.7143C5.5 9.76751 6.39543 9 7.5 9V8C7.5 5.23858 9.73858 3 12.5 3ZM17.5 11H7.5V19H17.5V11ZM12.5 12C13.6046 12 14.5 12.8954 14.5 14C14.5 14.7398 14.0983 15.3858 13.5011 15.7318L13.5 17C13.5 17.5523 13.0523 18 12.5 18C11.9477 18 11.5 17.5523 11.5 17L11.4999 15.7324C10.9022 15.3866 10.5 14.7403 10.5 14C10.5 12.8954 11.3954 12 12.5 12ZM12.5 5C10.9023 5 9.59634 6.24892 9.50509 7.82373L9.5 8V9H15.5V8C15.5 6.34315 14.1569 5 12.5 5Z"
                            fill="#323232" />
                    </svg>
                    <div class="lock-status mb-2">
                        <p class="lock-heading mb-1">{{'SHARED.SCOMP_VIEW.CONTENT_ACCESS.CONTENT_LOCKED' | translate}}</p>
                    </div>
                    <div class="mb-1">
                        @if (productViewHelperService.getIsAssignmentOnlyProduct() && !unlockDetail?.startTime) {
                            <p class="unlock-description">
                                {{'SHARED.SCOMP_VIEW.CONTENT_ACCESS.NO_ACCESS_ASSIGNMENT_ONLY_PRODUCT' | translate}}
                            </p>
                        } @else {
                            <p class="unlock-description">
                                {{'SHARED.SCOMP_VIEW.CONTENT_ACCESS.NO_ACCESS' | translate}}
                            </p>
                            <span [innerHTML]="'SHARED.SCOMP_VIEW.CONTENT_ACCESS.TIME_RANGE_START' | translate: {
                                startDate: unlockDetail?.startTime | date: 'MMM d, y',
                                startTime: unlockDetail?.startTime | date: 'HH:mm'
                            }"></span>
                        }
                        @if (unlockDetail && unlockDetail.endTime !== classEndDate) {
                            <span [innerHTML]="'SHARED.SCOMP_VIEW.CONTENT_ACCESS.TIME_RANGE_END' | translate: {
                                endDate: unlockDetail?.endTime | date: 'MMM d, y',
                                endTime: unlockDetail?.endTime | date: 'HH:mm'
                            }">
                            </span>
                        }
                    </div>
                </div>
                <div class="modal-footer px-0 justify-content-around">
                    <a href="javascript:void(0)" qid="scpv-alm-2" class="btn-text" data-dismiss="modal">
                        {{ 'SHARED.SCOMP_VIEW.CONTENT_ACCESS.GO_BACK' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
